import type { SubjectTypePayload } from '@Application/SubjectTypes/Actions/subjectTypesFetched';

/** The words an account uses to name one dossier of a type, many, the creation action, the empty list, the labels of the about and title fields and, when the type has a sheet, its title. */
class SubjectTypeWordingView {
	readonly singular: string;
	readonly plural: string;
	readonly createAction: string;
	readonly emptyList: string;
	readonly sheetTitle: string | null;
	readonly aboutLabel: string;
	readonly titleLabel: string;

	constructor(payload: SubjectTypePayload['wording']) {
		this.singular = payload.singular;
		this.plural = payload.plural;
		this.createAction = payload.createAction;
		this.emptyList = payload.emptyList;
		this.sheetTitle = payload.sheetTitle ?? null;
		this.aboutLabel = payload.aboutLabel;
		this.titleLabel = payload.titleLabel;

		Object.freeze(this);
	}
}

export default SubjectTypeWordingView;
